import styled from "styled-components"
import { below, Wrapper } from "../styles"
import { Body } from "./typography"

export const WorkBox = styled(Wrapper)`
  width: 30%;
  margin: 20px 10px;
  height: 220px;
  background-image: url(${p => p.img});
  background-color: ${p => p.theme.secondaryColor};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  border-radius: 5px;

  ${below.md`
    width: 47%;
  `};
  ${below.sm`
    width: 90%;
  `};
`

export const WorkBoxOverlay = styled(Wrapper)`
  height: auto;
  background: rgba(64, 64, 70, 0.9);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`

export const WorkBoxText = styled(Body)`
  padding: 0px;
  color: #ddd;
  font-size: 1.2em;
  margin: 10px 0;
  font-weight: 600;
`

export const WorkBack = styled.div`
  padding: 3px 6px;
  color: #fff;
  width: 70px;
  margin: 10px 0;
  text-align: center;
  border-radius: 5px;
  background: ${p => p.theme.secondaryColor};
  cursor: pointer;
`

export const WorkHr = styled.hr`
  color: #ccc;
  margin: 40px 0;
`

export const Video = styled.div`
  width: 640px;
  height: 360px;
  ${below.md`
    width: 300px;
    height: 200px;
  `};
`
